import { useState, useEffect } from 'react';
import { 
  LayoutDashboard, Users, Calendar, Wallet, TrendingUp, Receipt,
  Settings, LogOut, Bell, X,
} from 'lucide-react'; // Importem icones des de lucide-react 
import './Dashboard.css'; // Importem els estils per al Dashboard
import logoImg from '../assets/logo2.png'; // Importem la imatge del logo
import Clients from './Clients';
import Paquets from './Paquets';
import ControlHorari from './ControlHorari';
import Inici from './Inici';
import Rendibilitat from './Rendibilitat';
import Despeses from './Despeses';
import Configuracio from './Configuracio';
import Calendari from './Calendari';
import API_URL from '../config';

function Dashboard() {
  // ESTAT PER CONTROLAR QUINA SECCIÓ ES MOSTRA
  const [seccioActiva, setSeccioActiva] = useState('inici');
  const [usuari, setUsuari] = useState({ username: '' });

  const [mostrarAvisConfiguracio, setMostrarAvisConfiguracio] = useState(
    !localStorage.getItem('avis_configuracio_vist')  // Si no l'ha vist, mostrar
  );

  useEffect(() => {
    carregarUsuari();
  }, []);

  // FUNCIÓ PER RENDERITZAR (CANVIAR) EL CONTINGUT DEL MIG SEGONS LA SECCIÓ ACTIVA
  const renderContingut = () => {
    switch (seccioActiva) {
      case 'inici':
        return <Inici canviarSeccio={setSeccioActiva} />;
      case 'clients':
        return <Clients />;
      case 'paquets':
        return <Paquets />;
      case 'controlhorari':
        return <ControlHorari />;
      case 'rendibilitat':
        return <Rendibilitat />;
      case 'despeses':
        return <Despeses />;
      case 'configuracio':
        return <Configuracio />;
      case 'calendari':
        return <Calendari />;
    default:
        return <div>Secció no trobada</div>;
    }
  };

  const tancarSessio = () => {
    // Esborrar el token del sessionStorage per tancar sessió
    sessionStorage.removeItem('token');
    
    // Redirigir al login
    window.location.href = '/login';  
  };

  const tancarAvisConfiguracio = () => {
    setMostrarAvisConfiguracio(false);
    localStorage.setItem('avis_configuracio_vist', 'true');  // Marcar com a vist
  };

  const carregarUsuari = async () => {
    const token = sessionStorage.getItem('token');
    if (!token) return;

    try {
      const response = await fetch(`${API_URL}/api/gestio/usuari/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Dades usuari:', data); 
        setUsuari({ username: data.username });
      }
      else {
      console.log('Error resposta:', response.status);
      }
    } catch (err) {
      console.error('Error carregant usuari:', err);
    }
  };

  return (
    <div className="interficie-dashboard">
      
      {/* BARRA LATERAL */}
      <aside className="barra-lateral">
        <div className="logo-seccio">
          <img src={logoImg} alt="FitAnalytics Logo" className="logo-imatge" />
          <span className="nom-marca">FitAnalytics</span> {/* Nom de la marca al costat del logo  */}
        </div>

        <nav className="menu-navegacio">
          <div 
            className={`item-menu ${seccioActiva === 'inici' ? 'actiu' : ''}`} /* Aqui fem servir una classe condicional per marcar l'item actiu i que es posi del color que hem ficat al css */
            onClick={() => setSeccioActiva('inici')} /* Canvia la secció activa al clicar */
          >
            <LayoutDashboard size={18} /> <span>Inici</span>
          </div>
          <div 
            className={`item-menu ${seccioActiva === 'clients' ? 'actiu' : ''}`}
            onClick={() => setSeccioActiva('clients')}
          >
            <Users size={18} /> <span>Clients</span>
          </div>
          <div 
            className={`item-menu ${seccioActiva === 'paquets' ? 'actiu' : ''}`}
            onClick={() => setSeccioActiva('paquets')}
          >
            <Calendar size={18} /> <span>Sessions i paquets</span>
          </div>
          <div 
            className={`item-menu ${seccioActiva === 'controlhorari' ? 'actiu' : ''}`}
            onClick={() => setSeccioActiva('controlhorari')}
          >
            <Wallet size={18} /> <span>Control horari</span>
          </div>
          <div 
            className={`item-menu ${seccioActiva === 'rendibilitat' ? 'actiu' : ''}`}
            onClick={() => setSeccioActiva('rendibilitat')}
          >
            <TrendingUp size={18} /> <span>Rendibilitat</span>
          </div>
          <div 
            className={`item-menu ${seccioActiva === 'despeses' ? 'actiu' : ''}`}
            onClick={() => setSeccioActiva('despeses')}
          >
            <Receipt size={18} /> <span>Despeses</span>
          </div>
          <div 
            className={`item-menu ${seccioActiva === 'calendari' ? 'actiu' : ''}`}
            onClick={() => setSeccioActiva('calendari')}
          >
            <Calendar size={18} /> <span>Calendari</span>
          </div>
        </nav>

        <div className="menu-inferior">
          <div
            className={`item-menu ${seccioActiva === 'configuracio' ? 'actiu' : ''}`}
            onClick={() => setSeccioActiva('configuracio')}
            style={{ position: 'relative' }}
          >
            <Settings size={18} /> <span>Configuració</span>
            
            {/* RECUADRE D'AVÍS QUE APAREIX AL COSTAT BOTÓ CONFIG PER A QUAN UN USUARI ENTRA A L'APP, el pot tancar i desapareix */}
            {mostrarAvisConfiguracio && (
              <div className="avis-configuracio">
                <button className="boto-tancar-avis" onClick={tancarAvisConfiguracio}>
                  <X size={16} />
                </button>
                <p>👋 Registra la teva <strong>tarifa interna</strong> aquí per calcular els costos!</p>
              </div>
            )}
          </div>
          
          <div className="item-menu tancar-sessio" onClick={tancarSessio}>
            <LogOut size={18} /> <span>Surt</span>
          </div>
        </div>
      </aside>

      {/* CONTINGUT PRINCIPAL DEL MIG */}
      <main className="contingut-principal">
        
        <header className="barra-superior">
          <div className="perfil-usuari">
            <Bell size={20} className="notificacions" />
            <div className="avatar">
              {usuari.username ? usuari.username.charAt(0).toUpperCase() : 'E'}
            </div>
            <div className="detalls-usuari">
              <span className="nom-usuari">
                Entrenador {usuari.username ? usuari.username.charAt(0).toUpperCase() + usuari.username.slice(1).toLowerCase() : 'Admin'}
              </span>
              <span className="rol-usuari">Gestor</span>
            </div>
          </div>
        </header>

        <section className="zona-treball">
          {renderContingut()} {/* Renderitza el contingut segons la secció activa */}
        </section>
      </main>
    </div>
  );
}

export default Dashboard;